module.exports = __webpack_public_path__ + "img/green-square-table-8.dba64fe0.png";